import { render, staticRenderFns } from "./ISIHACView.vue?vue&type=template&id=19f661cd&"
import script from "./ISIHACView.vue?vue&type=script&lang=js&"
export * from "./ISIHACView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports